import moment from 'moment';
import { useQuery } from '@apollo/client';
import { AvatarHistory, AvatarStatus } from './types';
import {
  AvatarHistoryResponse,
  GET_ALL_PREDEFINED_AVATARS,
} from '../../apollo/queries/avatarUpload/uploadHistory.queries';

export const useAvatarHistoryQuery = () => {
  const { data, loading, error, refetch } = useQuery<AvatarHistoryResponse>(
    GET_ALL_PREDEFINED_AVATARS,
  );

  const getFormattedDate = (date: string): string => {
    const inputDate = moment.utc(date);
    return inputDate.format('Do MMM, YYYY');
  };

  const getAvatarHistory = (): AvatarHistory[] => {
    if (data && data.getAllPredefinedAvatars.length > 0) {
      return data.getAllPredefinedAvatars.map((item) => ({
        id: item.id,
        fileName: item.name,
        tenants: item.tenants,
        category: item.category,
        expiryDate: item.validTill ? getFormattedDate(item.validTill) : '-',
        genders: item.genders,
        organizations: item.organizations.map((o) => ({ id: o, name: o })),
        status: item.status as AvatarStatus,
        fileId: item.fileId,
        starCost: item.starCost,
        isEnabledForAllOrgs: item.isEnabledForAllOrgs,
      }));
    }
    return [];
  };

  return {
    loading,
    error,
    history: getAvatarHistory(),
    refetch,
  };
};
